import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Login.css";

function Login() {
  const [showRegister, setShowRegister] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.message) {
      setError(location.state.message);
    }
  }, [location]);

  const handleAdminLogin = async (event) => {
    event.preventDefault();
    const newCredentials = {
      username: event.target.username.value,
      password: event.target.password.value,
    };

    try {
      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/api/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newCredentials),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Login failed");
      }

      localStorage.setItem("adminCredentials", JSON.stringify(newCredentials));
      navigate("/");
      window.location.reload();
    } catch (err) {
      setError(err.message || "Failed to login");
    }
  };

  const handleRegister = async (event) => {
    event.preventDefault();
    const newUser = {
      username: event.target.username.value,
      password: event.target.password.value,
    };

    try {
      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/api/register`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newUser),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        if (data.error === "Registration failed") {
          throw new Error("This username is already taken");
        }
        throw new Error(data.error || "Registration failed");
      }

      setError("");
      setShowRegister(false);
      event.target.reset();
    } catch (err) {
      setError(err.message || "Failed to register");
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        {showRegister ? (
          <form onSubmit={handleRegister} className="login-form">
            <h2>Create Account</h2>
            <input
              type="text"
              name="username"
              placeholder="Username"
              required
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              required
            />
            <button type="submit" className="submit-button">
              Register
            </button>
            <button
              type="button"
              className="switch-button"
              onClick={() => setShowRegister(false)}
            >
              Already have an account? Login
            </button>
          </form>
        ) : (
          <form onSubmit={handleAdminLogin} className="login-form">
            <h2>Login</h2>
            <input
              type="text"
              name="username"
              placeholder="Username"
              required
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              required
            />
            <button type="submit" className="submit-button">
              Login
            </button>
            <button
              type="button"
              className="switch-button"
              onClick={() => setShowRegister(true)}
            >
              Need an account? Register
            </button>
          </form>
        )}
        {error && <p className="error">{error}</p>}
      </div>
    </div>
  );
}

export default Login;
